import React, { useState } from 'react';
import PropTypes from 'prop-types';

import {
  CircularProgress,
  TextField,
} from '@material-ui/core';
import LocationSearchingIcon from '@material-ui/icons/LocationSearching';
import CloseIcon from '@material-ui/icons/Close';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';

import './Search.scss';

import { search } from '../../Utilities/Data';



export default function Search({ handleSearchLocationChange }) {
  const [loading, setLoading] = useState(false);
  const [terms, setTerms] = useState('');
  const [searchVisible, setSearchVisible] = useState(false);


  const handleChange = (event) => {
    setTerms(event.target.value);
  };

  
  const handleSearch = async (event, text = null) => {
    if (event.key === 'Enter' || text === 'search') {
      setLoading(true);
      let results = await search(terms);
      setTerms(results.name);
      handleSearchLocationChange(results);
      setLoading(false);
    }
  };


  // Clears search bar and hides it if clicking anywhere but in the component
  const handleClick = () => {
    document.getElementById('grid').addEventListener('click', function (event) {
      const clicked = event.target;
      const container = document.getElementById('search-container');
      if (!searchVisible && container !== clicked && !container.contains(clicked)) {
        setSearchVisible(false);
      }
    });
    
    setTerms('');
    setSearchVisible(!searchVisible);
  };


  return (
    <div id="search-container" className={`card ${!searchVisible ? 'search-hidden' : ''}`}>
      <div id="search-icon" onClick={handleClick}>{searchVisible ? <CloseIcon /> : <LocationSearchingIcon />}</div>
      <TextField
        id="search-field"
        label="Search"
        placeholder="i.e. Ithaca, NY"
        fullWidth
        inputMode="search"
        value = {terms}
        onKeyDown={handleSearch}
        onChange={handleChange}
        style = {{width:'calc(100% - 20px)'}}
        InputProps={{
          endAdornment: (
            <>
              {loading ? <CircularProgress color="inherit" size={20} /> : null}
              {terms !== '' ? <ArrowForwardIcon id="enter-arrow" onClick={(e) => handleSearch(e, 'search')} /> : null}
            </>
          ),
        }}
      />
    </div>
  );
}

Search.propTypes = {
  handleSearchLocationChange: PropTypes.func
};